import Link from './Link'
export default Link



// WEBPACK FOOTER //
// ./src/atoms/Link/index.js